// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-table-container {
  margin: 2rem 0;
  overflow-x: auto;
}

.documents-table {
  border-collapse: collapse;
  width: 100%;
  background: #fff;
}

.documents-table th,
.documents-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: top;
  min-width: 120px;
}

.documents-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.documents-table td {
  font-size: 1rem;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #888;
}

.d-flex {
  display: flex;
}

.justify-content-end {
  justify-content: flex-end;
}

.mt-3 {
  margin-top: 1rem;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.v-align-middle {
  vertical-align: middle !important;
}

.hidden {
  display: none !important;
}

.file-name-link {
  color: #1976d2;
  text-decoration: none;
  cursor: pointer;
}
.file-name-link:hover {
  text-decoration: underline;
}
.file-name-link:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.status-history-item {
  padding-bottom: 0.5rem;
}

hr.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.gap-4 {
  gap: 2rem;
}

.status-history-scroll {
  max-height: 18rem;
  overflow-y: auto;
}

.status-history-status-row {
  gap: 4rem !important;
}

.status-history-status-col {
  min-width: 180px;
  margin-right: 2rem;
}

.fw-bold {
  font-weight: 600;
}

.text-muted {
  color: #888;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/documents-list/documents-list.component.scss","webpack://./src/app/shared/components/dispute-resolution/status-changes/status-changes.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;ACCF;;ADEA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;ACCF;;ADEA;;EAEE,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;ACCF;;ADEA;EACE,mBAAA;EACA,gBAAA;ACCF;;ADEA;EACE,eAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,WAAA;ACCF;;ADEA;EACE,aAAA;ACCF;;ADEA;EACE,yBAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;ACCF;;ADEA;EACE,iCAAA;ACCF;;ADEA;EACE,wBAAA;ACCF;;ADEA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;ACCF;ADCE;EACE,0BAAA;ACCJ;ADEE;EACE,0BAAA;EACA,mBAAA;ACAJ;;AA5EA;EACE,sBAAA;AA+EF;;AA7EA;EACE,kBAAA;EACA,qBAAA;AAgFF;;AA9EA;EACE,SAAA;AAiFF;;AA/EA;EACE,iBAAA;EACA,gBAAA;AAkFF;;AA/EA;EACE,oBAAA;AAkFF;;AA/EA;EACE,gBAAA;EACA,kBAAA;AAkFF;;AA/EA;EACE,gBAAA;AAkFF;;AAhFA;EACE,WAAA;AAmFF","sourcesContent":[".documents-table-container {\r\n  margin: 2rem 0;\r\n  overflow-x: auto;\r\n}\r\n\r\n.documents-table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  background: #fff;\r\n}\r\n\r\n.documents-table th,\r\n.documents-table td {\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  vertical-align: top;\r\n  min-width: 120px;\r\n}\r\n\r\n.documents-table th {\r\n  background: #f5f5f5;\r\n  font-weight: 600;\r\n}\r\n\r\n.documents-table td {\r\n  font-size: 1rem;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-muted {\r\n  color: #888;\r\n}\r\n\r\n.d-flex {\r\n  display: flex;\r\n}\r\n\r\n.justify-content-end {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.mt-3 {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.visually-hidden {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.v-align-middle {\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.hidden {\r\n  display: none !important;\r\n}\r\n\r\n.file-name-link {\r\n  color: #1976d2;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    text-decoration: underline;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 2px solid #1976d2;\r\n    outline-offset: 2px;\r\n  }\r\n}","@import \"../documents-list/documents-list.component.scss\";\r\n\r\n.status-history-item {\r\n  padding-bottom: 0.5rem;\r\n}\r\nhr.my-2 {\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n.gap-4 {\r\n  gap: 2rem;\r\n}\r\n.status-history-scroll {\r\n  max-height: 18rem; // enough for 3 items, adjust as needed\r\n  overflow-y: auto;\r\n}\r\n\r\n.status-history-status-row {\r\n  gap: 4rem !important; // wider gap between Initial and Updated Status\r\n}\r\n\r\n.status-history-status-col {\r\n  min-width: 180px;\r\n  margin-right: 2rem;\r\n}\r\n\r\n.fw-bold {\r\n  font-weight: 600;\r\n}\r\n.text-muted {\r\n  color: #888;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
